import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { PaperflowService } from 'app/services/paperflow.service';
import { SickLeaveListService } from 'app/services/sick-leave-list.service';


@Component({
  selector: 'app-paperflow-list',
  templateUrl: './paperflow-list.component.html',
  styleUrls: ['./paperflow-list.component.css']
})
export class PaperflowListComponent implements OnInit {

  public p;
  public selectAllFlag: boolean;
  public filterLeaveListTerm = "";
  public isDesc;
  public column;
  public direction;
  public paperflowListFlag: any;
  public updatedHrExpert: any;
  public editFlagForHr: boolean;
  public editFlagForExpert: boolean;
  public currentIndexOfHr: number;
  public currentIndexOfExpert: number;
  public defaultFilters = [];
  public outputListForVariousFilters = [];
  public groupFilterValue;
  public issuesFilterList =
    [
      'Identical Match',
      'Partial Match',
      'No Match',
      'No OCR'
    ];
  public hrStatusFilterList = [
    'To be checked',
    'Match',
    'Duplicate',
    'No Match',
    'On Hold',
    'Created in PSFT',
    'Failed',
    'Invalid Certificate'

  ];
  public filterString = '|';
  public filterObject = {
    hrStatus: [],
    matchType: []
  };
  public paperflowList = [];
  public hrFilterFlag: boolean;
  public expertFilterFlag: boolean;
  public issueFilterFlag: boolean;
  public nameFilterFlag: boolean;
  public totalCount: number;
  public hrUnjustifiedCount: number;

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public paperflowService: PaperflowService,
    public sickLeaveListService: SickLeaveListService) { }

  ngOnInit() {
    this.totalCount = 0;
    this.hrUnjustifiedCount = 0;
    this.direction = 0;
    this.p = 1;
    this.column = 'CategoryName';
    this.selectAllFlag = false;
    this.isDesc = false;

    this.hrFilterFlag = true;
    this.expertFilterFlag = true;
    this.issueFilterFlag = true;
    this.nameFilterFlag = true;
    this.paperflowListFlag = false;

    if (sessionStorage.getItem('gfvp') === null || sessionStorage.getItem('gfvp') === '') {
      sessionStorage.setItem('gfvp', '');
    } else {
      this.filterObject = JSON.parse(sessionStorage.getItem('gfvp'));
      this.filterString = this.filterToString();
    }

    this.getScanCertificateList();
  }

  filterToString() {
    return this.filterObject.hrStatus.toString()
      + '|' + this.filterObject.matchType.toString();
  }

  getRefreshCertificateList(){
    this.paperflowListFlag = false;
    this.getScanCertificateList()
  }

  getScanCertificateList() {
    this.paperflowService.getScanCertificateList()
      .subscribe(
        (res: any) => {
          this.paperflowListFlag = res.status === 'success' ? true : false;
          this.paperflowList = res.response;
          this.totalCount = this.paperflowList.length;
          for (let i = 0; i < this.totalCount; i++) {
            if (this.paperflowList[i].verificationResults.trim() === 'To be checked') {
              this.hrUnjustifiedCount++;
            }
          }
        },
        (err) => {
          if (err.status === 401) {
            alert('You are either unauthorized or your seesion is expired!');
            this.sickLeaveListService.redirectToSAB();
          }
          this.paperflowListFlag = true;
          this.paperflowList = [];
        });
  }

  processFilterObject(array, itemValue) {
    if (itemValue !== null && itemValue.trim() !== '') {
      if (array.indexOf(itemValue) !== -1) {
        array.splice(array.indexOf(itemValue), 1);
        return array;
      }
      else {
        array.push(itemValue);
        return array;
      }
    }
    return array;
  }

  updateList(itemValue, type) {
    let temp = [];
    if (type === 'hradmin') {
      temp = this.processFilterObject(this.filterObject.hrStatus, itemValue);
      this.filterObject.hrStatus = temp;
    } else if (type === 'matchType') {
      temp = this.processFilterObject(this.filterObject.matchType, itemValue);
      this.filterObject.matchType = temp;
    }
    sessionStorage.setItem('gfvp', JSON.stringify(this.filterObject));
    // console.log();
    this.filterString = this.filterToString();
    // console.log(this.filterString);
  }

  selectAll() {
    for (let i = 0; i < this.paperflowList.length; i++) {
      this.paperflowList[i]['selected'] = this.selectAllFlag;
    }
  }

  checkIfAllSelected() {
    this.selectAllFlag = this.paperflowList.every((item: any) => {
      return item.selected === true;
    });
  }

  sortBy(property: string) {
    this.isDesc = !this.isDesc;
    this.column = property;
    this.direction = this.isDesc ? 1 : -1;
  };

  toHRCCCertificateView(item) {
    this.router.navigate(['pfl/hrccCertificateView', item.certificateID, item.employeeID]);
  }
}



// WEBPACK FOOTER //
// ./src/app/paperflow-list/paperflow-list.component.ts